exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "iframe[data-v-521185fa]{height:1500px;border:0;margin:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-521185fa&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./assets/js/page/Purchase.vue
// module id = 53
// module chunks = 0